import PropTypes from "prop-types";
import classNames from "classnames";

const IconMedia = ({ className, height = "32px", width = "32px" }) => {
    const classes = classNames("mediaIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 200 200"
            focusable="false"
            aria-label="play"
        >
            <circle cx="100" cy="100" r="100" fill="none" strokeWidth="30" />
            <polygon points="70, 55 70, 145 145, 100" />
        </svg>
    );
};

IconMedia.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconMedia;
